import { environment } from '@upkey-platform/core/core-shared'

export const PROFILE_API_URL = {
  getUser: `${environment.apiUrl}/users/get-user`,
  updateProfile: `${environment.apiUrl}/users/update-profile`,
  overrideProfile: `${environment.apiUrl}/users/override-profile`
}
